import React, { useState , useEffect } from "react";
import axios from "axios";
import Aos from 'aos';
import { Translation  , useTranslation} from "react-i18next";
import { API_URL } from "../config";

export default function Talk() {
  const {t} = useTranslation();
     useEffect(()=> {
      Aos.init({duration: 1000});
        });

  const [form, setForm] = useState({
    name: "",
    rating: 5,
    message: "",
    imageFile: null, 
    imagePreview: null, 
  });
  const [sending, setSending] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      const file = files[0];
      if (file) {
        setForm((p) => ({
          ...p,
          imageFile: file,
          imagePreview: URL.createObjectURL(file),
        }));
      }
    } else {
      setForm((p) => ({ ...p, [name]: value }));
    }
  };

  const resetForm = () => {
    
    if (form.imagePreview) URL.revokeObjectURL(form.imagePreview);
    setForm({ name: "", rating: 5, message: "", imageFile: null, imagePreview: null });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!form.name.trim() || !form.message.trim()) {
      alert("فضلاً املئي الاسم والتعليق");
      return;
    }

    setSending(true);
    try {
      
      let payload = {
        name: form.name.trim(),
        rating: Number(form.rating),
        message: form.message.trim(),
        createdAt: new Date().toISOString(),
      };

     
      if (form.imageFile) {
        const toBase64 = (file) =>
          new Promise((res, rej) => {
            const reader = new FileReader();
            reader.onload = () => res(reader.result);
            reader.onerror = (err) => rej(err);
            reader.readAsDataURL(file);
          });
        const b64 = await toBase64(form.imageFile);
        payload.image = b64; 
      }

      
      await axios.post(`${API_URL}/comments`, payload, {
        headers: { "Content-Type": "application/json" },
      });

      setSuccessMsg("تم إرسال تعليقك بنجاح — شكراً ليك!");
      resetForm();

      setTimeout(() => setSuccessMsg(""), 3000);
    } catch (err) {
      console.error(err);
      alert("حصل خطأ في الإرسال. حاولي بعد شوية.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div data-aos="fade-up" className="mx-auto rounded shadow-2xl p-6 md:w-[80%] w-screen">
      <h3 className="text-2xl font-bold mb-4">{t("comment")}</h3>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium mb-1  ">{t("name")}</label>
          <input 
            name="name"
            value={form.name}
            onChange={handleChange}
            className="w-full border rounded-full  px-3 py-2 "
            placeholder="Name"

          
          />
        </div>

        <div>
          <label className="block text-sm font-medium mb-1">{t("rating")}</label>
          <select
            name="rating"
            value={form.rating}
            onChange={handleChange}
            className="border rounded-full px-3 py-2 "
          >
            <option value={5}>5 — Exlant</option>
            <option value={4}>4 — Very Good </option>
            <option value={3}>3 — Good</option>
            <option value={2}>2 — Week</option>
            <option value={1}>1 — Bad</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium mb-1">{t("comment2")}</label>
          <textarea
            name="message"
            value={form.message}
            onChange={handleChange}
            rows={5}
            className="w-full border rounded px-3 py-2 "
            placeholder="       Write your comment.."
          />
        </div>

        <div>
          <label className="block text-sm font-medium mb-1">{t("photo (ghos)")}</label>
          <input type="file" accept="image/*" name="image" onChange={handleChange} />
          {form.imagePreview && (
            <div className="mt-2">
              <img src={form.imagePreview} alt="preview" className="w-28 h-28 object-cover rounded border" />
            </div>
          )}
        </div>

        <div className="flex items-center gap-3">
          <button
            type="submit"
            disabled={sending}
            className="bg-blue-400 text-white px-4 py-2 rounded disabled:opacity-60"
          >
            {sending ? "Sending ..." : " Send"}
          </button>

          {successMsg && <div className="text-blue-600">{successMsg}</div>}
        </div>
      </form>
    </div>
  );
}
